import { useEffect, useState } from 'react';
import { loadBankData } from '../services/bankLedger';

export function useBankLedger(filters) {
    const [data,setData] = useState(null);
    const [error,setError] = useState(null);
    const [loading,setLoading] = useState(true);
    const [version,setVersion] = useState(0);
    const params = new URLSearchParams(Object.entries(filters).filter(([,value]) => value !== '' && value !== null)).toString();
    useEffect(() => {
        const controller = new AbortController();
        setLoading(true); setError(null);
        Promise.all([loadBankData(`movements?${params}`,controller.signal),loadBankData('accounts',controller.signal)])
            .then(([ledger,accounts]) => { if (!controller.signal.aborted) setData({...ledger,...accounts}); })
            .catch(e => { if (!controller.signal.aborted) setError(e.message); })
            .finally(() => { if (!controller.signal.aborted) setLoading(false); });
        return () => controller.abort();
    },[params,version]);
    return {data,error,loading,refresh:()=>setVersion(value=>value+1)};
}
